import { subscribeFCM, unsubscribeFCM } from '$lib/firebase/fcm';
import { browser } from '$app/environment';
import { stateNotificationsPermissions } from '$states/notificationsPermissions.svelte';
import { subscriptionStatus } from '$states/subscriptionStatus.svelte';
import type { NotificationPreferences } from '$types/pushNotifications';

export const requestNotificationPermission = async (): Promise<NotificationPermission> => {
  if (!browser || !('Notification' in window)) {
    return 'denied';
  }

  if (Notification.permission !== 'default') {
    stateNotificationsPermissions.set(Notification.permission);
    return Notification.permission;
  }

  try {
    const permission = await Notification.requestPermission();
    stateNotificationsPermissions.set(permission);
    return permission;
  } catch (_) {
    stateNotificationsPermissions.set('denied');
    return 'denied';
  }
};

export const addSubscription = async (
  address: string | undefined,
  preferences: NotificationPreferences,
): Promise<void> => {
  if (!address) {
    return;
  }

  await subscribeFCM(address, preferences);
  subscriptionStatus.updateSubscription(address, true, preferences);
};

export const deleteSubscription = async (address: string | null | undefined): Promise<void> => {
  if (!address) {
    return;
  }

  await unsubscribeFCM(address);
  subscriptionStatus.updateSubscription(address, false, null);
};
